// Ortak (taşeron + ana firma portalı) — T.C. kimlik no maskeli görünüm (D17/F6). Özet kartında
// (taşeron `PersonnelDrawer`) doğdu; ortak düzenleme formu ve her iki portalın çekmecesi AYNI
// şekilde tüketir — QA ikincisinin çıplak metin `readOnly` input'ta göründüğünü, maskesiz/reveal'sız bulana kadar
// güvenlik incelemesinin kapsamı yalnız özet kartına yazılmıştı (aynı D17/F6 tehdidi: `Düzenle`
// rutin sebeplerle — `isActive`/`accessLevel` değişimi — açılır, T.C. her seferinde ifşa olurdu).
//
// **Kontrollü bileşen — reveal state'i ÇAĞIRANDA.** Sıfırlama tetikleyicisi konağa göre değişir
// (özet kartında sekme değişimi, düzenleme kipine her giriş) — bu yüzden `revealed`/`onToggle`
// dışarıdan gelir, burada yalnız GÖRÜNÜM var. Maske `maskTcKimlikNo` (`tcKimlik.ts`) ile
// HESAPLANIR; `revealed=false` iken tam değer bu bileşenin render ettiği hiçbir düğüme
// (DOM/erişilebilirlik ağacı/tümünü-seç kopyası) girmez.
import { useTranslation } from 'react-i18next';
import { maskTcKimlikNo } from './tcKimlik';

interface TcKimlikValueProps {
  tcKimlikNo: string;
  revealed: boolean;
  onToggle: () => void;
  /** Verilirse Göster/Gizle düğmesine uygulanır — bir `Field`in `htmlFor`ıyla (native input
   * yerine bu bileşen render edildiğinde) eşleşmesi için (ortak düzenleme formu). */
  id?: string;
  /** Alan etiketinin `id`'si (ör. çekmece özetindeki `dt`) — düğme "Göster" yerine alanıyla
   * birlikte okunsun (GL5 R10). Açıklamaya yalnız ETİKET girer, T.C. hanesi ASLA. */
  describedBy?: string;
}

export function TcKimlikValue({
  tcKimlikNo,
  revealed,
  onToggle,
  id,
  describedBy,
}: TcKimlikValueProps) {
  const { t } = useTranslation();
  return (
    <span className="inline-flex flex-wrap items-center gap-2">
      <span className="tabular-nums">{revealed ? tcKimlikNo : maskTcKimlikNo(tcKimlikNo)}</span>
      <button
        id={id}
        type="button"
        aria-pressed={revealed}
        aria-describedby={describedBy}
        onClick={onToggle}
        className="rounded text-xs font-medium text-muted underline-offset-2 hover:text-fg hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        {revealed ? t('personnelForm.tc.hide') : t('personnelForm.tc.show')}
      </button>
    </span>
  );
}
